import React from "react";

import { Body2 } from "Cobalt/BodyText";
import { Title } from "Cobalt/Header";
import { Modal, ModalBody, ModalHeader, ModalFooter, type ModalHook } from "Cobalt/Modal";
import Button from "Common/Button";

export interface RenewalCarrierChangeModalProps extends ModalHook {
  onConfirm: () => void;
}

export const RenewalCarrierChangeModal = ({ isShowing, hide, onConfirm }: RenewalCarrierChangeModalProps) => {
  return (
    <Modal show={isShowing} onHide={hide}>
      <ModalHeader closeButton>
        <Title>Confirm Carrier Change?</Title>
      </ModalHeader>
      <ModalBody>
        <Body2>
          You have a selected a plan with a different carrier than your current carrier. Changing carriers at renewal will require you and your employees to
          complete new applications and may result in longer processing times and a lapse in coverage. Please confirm you would like to continue with this
          carrier change.
        </Body2>
      </ModalBody>
      <ModalFooter>
        <Button color="gray" key="close" onClick={hide}>
          Cancel
        </Button>
        <Button onClick={onConfirm}>Confirm</Button>
      </ModalFooter>
    </Modal>
  );
};
